<ng-container *ngIf="(formgroup != null)" [formGroup]="formgroup">
  <ng-container
    *ngIf="(ie.CustomizeOptions != null  && ie.CustomizeOptions.DisplayType == 'flexbox' ); else datePicker">
    <div class="mb-2">
      <app-cosy-flexbox [ie]="ie" [entityFormGroup]="formgroup"></app-cosy-flexbox>
    </div>
  </ng-container>
  <ng-template #datePicker>
    <ng-container
      *ngIf="(ie.CustomizeOptions  != null  && ie.CustomizeOptions.DisplayType == 'date'); else customDisplayTypesTextarea">
      <div class="input-group input-group-sm mb-2">
        <input [class]="BackGroundInput" type="text" #ieinput [placeholder]="datePlaceHolder" ngbDatepicker
          #d="ngbDatepicker"
          (input)="fetchIEUserAction(ie.Attributes.OnChangeUAID, ieinput.value, null, null, null, formgroup)"
          (dateSelect)="fetchIEUserAction(ie.Attributes.OnChangeUAID, ieinput.value, null, null, null, formgroup)"
          [id]="ie.InterfaceElementID"
          [formControlName]="ie.InterfaceElementID">
        <div class="input-group-append">
          <button class="btn btn-sm btn-outline-secondary" (click)="d.toggle()" type="button"
            [disabled]="formgroup.disabled"><i id="button_DatePicker"></i></button>
        </div>
      </div>
    </ng-container>
  </ng-template>
  <ng-template #customDisplayTypesTextarea>
    <ng-container
      *ngIf="(ie.CustomizeOptions != null  && ie.CustomizeOptions.DisplayType == 'textarea'); else hidden">
      <div 
        class="input-group input-group-sm mb-2">
        <textarea #ieeinputarea [class]="BackGroundInput "
          (input)="fetchIEUserAction(ie.Attributes.OnChangeUAID, ieeinputarea.value)"
          [id]="ie.InterfaceElementID"
          [formControlName]="ie.InterfaceElementID" 
          [rows]="ie.CustomizeOptions.Properties.Rows">
        </textarea>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #hidden>
    <ng-container
      *ngIf="(ie.CustomizeOptions != null   && ie.CustomizeOptions.DisplayType == 'hidden'); else textBoxOrPassword">
      <input type="hidden" #ieeinputhidden
        (onchance)="fetchIEUserAction(ie.Attributes.OnChangeUAID, ieeinput.value, null, null, null, formgroup)"
        [id]="ie.InterfaceElementID"
        [formControlName]="ie.InterfaceElementID">
    </ng-container>
  </ng-template>

  <ng-template #textBoxOrPassword>
   
    <ng-container
    *ngIf="(ie.CustomizeOptions != null  && ie.CustomizeOptions.DisplayType == 'password'); else defaultTextBox">
      <div class="input-group input-group-sm mb-2">
        <input [class]="BackGroundInput" type="password" #ieeinput
          (input)="fetchIEUserAction(ie.Attributes.OnChangeUAID, ieeinput.value, null, null, null, formgroup)"
          [id]="ie.InterfaceElementID"
          [formControlName]="ie.InterfaceElementID">
          <span *ngIf="ie.Attributes.Required" class="input-group-text cosyColorRequired">*</span>
      </div>
    </ng-container>
    <ng-template #defaultTextBox>
      <div  *ngIf="(isAPOS == true)"class="input-group input-group-sm mb-2">
         <input [class]="BackGroundInput" type="text" #ieeinput
          (keyup.enter)="fetchIEUserAction(ie.Attributes.OnChangeUAID, ieeinput.value, null, null, null, formgroup)"  
          (blur)="fetchIEUserAction(ie.Attributes.OnChangeUAID, ieeinput.value, null, null, null, formgroup)" 
          [id]="ie.InterfaceElementID"
          [formControlName]="ie.InterfaceElementID">
          <span *ngIf="ie.Attributes.Required" class="input-group-text cosyColorRequired">*</span>
      </div>
      <div  *ngIf="(isAPOS == false)"class="input-group input-group-sm mb-2">
        <input [class]="BackGroundInput" type="text" #ieeinput
         (input)="fetchIEUserAction(ie.Attributes.OnChangeUAID, ieeinput.value, null, null, null, formgroup)"  
         [id]="ie.InterfaceElementID"
         [formControlName]="ie.InterfaceElementID">
         <span *ngIf="ie.Attributes.Required" class="input-group-text cosyColorRequired">*</span>
     </div>
      <div
        *ngIf="(ie.CustomizeOptions!= null && ie.CustomizeOptions.DisplayType=='document' && ie.CustomizeOptions.Mode != 'withoutUpload')"
        class="">
        <app-cosy-upload-file [config]="afuConfig" [documentID]="ie.Values[0].Value"
          [mode]="ie.CustomizeOptions.Mode"
          (newDocumentID)="setDocumentID($event, ie, formgroup);fetchIEUserAction(ie.Attributes.OnChangeUAID, $event, null, null, null, formgroup)">
        </app-cosy-upload-file>
      </div>
    
    </ng-template>
  </ng-template>
</ng-container>

<div [class]="formClass" *ngIf="(formgroup == null)">
  <ng-container *ngIf="label">
    <label class="col-sm-2 col-form-label" [attr.for]="ie.interfaceElementID" *ngIf="(ie.PreLabel!=null)">{{ie.PreLabel.DisplayName}}</label>
  </ng-container>
  <div *ngIf="(ie.CustomizeOptions != null  && ie.CustomizeOptions.DisplayType == 'textarea'); else datePicker">
    <div >
      <textarea #ieinputarea data-info="textarea-words-info" class="form-control input-sm"
        (input)="fetchIEUserAction(ie.Attributes.OnChangeUAID, ieinputarea.value)"
        [id]="ie.InterfaceElementID" [rows]="ie.CustomizeOptions.Properties.Rows" [value]="">
      </textarea>
    </div>
  </div>
  <ng-template #datePicker>
    <div class="col-sm-10">
    <ng-container
      *ngIf="(ie.CustomizeOptions  != null  && ie.CustomizeOptions.DisplayType == 'date'); else defaultOfTextBox">
      <div class="input-group input-group-sm mb-2">
        <input [class]="BackGroundInput" type="text" #ieinput [placeholder]="datePlaceHolder" [(ngModel)]="ieValue"  ngbDatepicker
          #d="ngbDatepicker"
          (input)="fetchIEUserAction(ie.Attributes.OnSelectUAID, ieinput.value)"
          (dateSelect)="fetchIEUserAction(ie.Attributes.OnSelectUAID, ieinput.value)"
          [id]="ie.InterfaceElementID"
          [disabled]="!ie.Attributes.Enabled">
        <div class="input-group-append">
          <button class="btn btn-sm btn-outline-secondary" (click)="d.toggle()" type="button" [disabled]="!ie.Attributes.Enabled">
            <i id="button_DatePicker"></i></button>
        </div>
      </div>
    </ng-container>
    </div>
  </ng-template>
  <ng-template #defaultOfTextBox>
    <input class="form-control form-control-sm" type="text" #ieinputnum
      (input)="fetchIEUserAction(ie.Attributes.OnChangeUAID, ieinputnum.value)"
      [id]="ie.InterfaceElementID" [value]="">
  </ng-template>
</div>
